import { Add } from 'iconsax-react'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { socialMediaSheetSchemaType } from '@/utils/schemas'

import { SOCIAL_PLATFORMS } from '../constants/socialPlatforms'

import { SocialMediaSheet } from './SocialMediaSheet'

interface SocialMediaAccountsFieldProps {
  name?: string
  hint?: string
}

export const SocialMediaAccountsField = ({
  name = 'socialMedia',
  hint,
}: SocialMediaAccountsFieldProps) => {
  const { t } = useTranslation()
  const { watch, setValue } = useFormContext()
  const [open, setOpen] = useState(false)

  const value = (watch(name) ?? {}) as socialMediaSheetSchemaType

  const handleSave = (next: socialMediaSheetSchemaType) => {
    setValue(name, next, { shouldValidate: true, shouldDirty: true })
  }

  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between gap-4">
          <p className="text-base font-medium text-neutralColor lg:text-xl">
            {t('dashboard.runReport.confirmSubjectDetails.socialMediaTitle')}
          </p>
          <Button
            type="button"
            variant="secondary"
            className="gap-2"
            onClick={() => setOpen(true)}
          >
            {t(
              'dashboard.runReport.confirmSubjectDetails.addSocialMediaProfiles',
            )}
            <Add size="16" color="currentColor" />
          </Button>
        </div>

        {hint && <p className="text-sm text-neutralColor60">{hint}</p>}

        <div className="flex flex-wrap items-center gap-3">
          {SOCIAL_PLATFORMS.map(({ key, Icon }) => {
            const isFilled = Boolean(value[key]?.trim())
            return (
              <span
                key={key}
                className={cn(
                  'flex h-[46px] w-[46px] items-center justify-center rounded-full border',
                  isFilled
                    ? 'border-neutralColor bg-neutralColor text-baseColor'
                    : 'border-dashed border-neutralColor5 text-neutralColor60',
                )}
              >
                <Icon className="h-4 w-4" />
              </span>
            )
          })}
        </div>
      </div>

      <SocialMediaSheet
        open={open}
        onOpenChange={setOpen}
        value={value}
        onSave={handleSave}
      />
    </>
  )
}
